import { collectOrgIdsForAnyOrgPermission, requireAnyOrgPermission, requireAnySystemPermission, } from '@juvare/contact-management/backend/features/permissions/shared';
export function allowManageAnnouncement(announcement, userState) {
    const hasSystemPermission = requireAnySystemPermission(userState, 'manage-announcements');
    const isPublic = announcement.columns.public;
    if (hasSystemPermission) {
        return true;
    }
    if (isPublic) {
        return hasSystemPermission;
    }
    // Can only manage announcements if user has 'manage-org-announcements' org permission in all organizations that announcement is shared with
    if (requireAnyOrgPermission(userState, 'manage-org-announcements')) {
        const organizationIdsUserHasPermission = collectOrgIdsForAnyOrgPermission(userState, 'manage-org-announcements');
        const organizationsIdsAnnouncementIsSharedWith = announcement.columns.visibility;
        return organizationsIdsAnnouncementIsSharedWith.every((id) => organizationIdsUserHasPermission.includes(id));
    }
    return false;
}
